define.alias("shared/utils/array-filters/get-last-value", "calendar/utils/array-filters/get-last-value");